import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Button, Stack } from '@material-ui/core'
import { clog } from './stuff'

function App() {
    return <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={() => {
            clog("First clicked")
        }}>First</Button>

        <Button variant="contained" onClick={() => {
            clog("Second clicked")
        }}>Second</Button>
    </Stack>
}

clog('NODE_ENV: ' + process.env.NODE_ENV)

ReactDOM.render(<App />, document.querySelector('#app'))
